var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcn2Process(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.267,
    height: 86.936,
    viewBox: "0 0 86.267 86.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn2-process",
    transform: "translate(-859.35 -1753.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2427",
    "data-name": "Groupe 2427",
    transform: "translate(859.35 1753.645)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 86.267,
    height: 86.936,
    rx: 20,
    fill: "#defdff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2638",
    "data-name": "Groupe 2638",
    transform: "translate(884.35 1779.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2969",
    "data-name": "Trac\\xE9 2969",
    d: "M221.445,285.359a4.484,4.484,0,0,1-.557.725,1.331,1.331,0,0,1-1.521.21,1.454,1.454,0,0,1-.88-1.328c-.023-.541,0-1.084,0-1.7h-.647q-10.505,0-21.011,0c-.321,0-.532-.024-.656-.4a14.349,14.349,0,0,0-5.682-7.554c-.081-.055-.156-.119-.27-.206a10.33,10.33,0,0,0,2.064-9.227h.624q13.274,0,26.548-.013a1.909,1.909,0,0,1,1.993,1.1Z",
    transform: "translate(-176.812 -244.978)",
    fill: "#00bcc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2970",
    "data-name": "Trac\\xE9 2970",
    d: "M14.471-6a13.627,13.627,0,0,1,2.421,1.029A5.169,5.169,0,0,1,19.211-.464c.015,2.323,0,4.647.015,6.971a1.609,1.609,0,0,0,.245.816c.821,1.273,1.667,2.53,2.516,3.785a1.583,1.583,0,0,1,.214,1.756,1.609,1.609,0,0,1-1.584.8c-7,0-14.007.009-21.011-.006A5.415,5.415,0,0,1-5.916,9.1.719.719,0,0,0-6,8.933V-1.253a1.96,1.96,0,0,0,.094-.27A5.207,5.207,0,0,1-3.261-5.251,13.721,13.721,0,0,1-1.253-6ZM6.608,2.513v0c1.53,0,3.061,0,4.591,0A1.5,1.5,0,0,0,12.853,1.07,1.527,1.527,0,0,0,11.195-.445Q6.6-.458,2.013-.436a2.136,2.136,0,0,0-.98.261A1.39,1.39,0,0,0,.412,1.406a1.452,1.452,0,0,0,1.408,1.1C3.416,2.525,5.012,2.513,6.608,2.513ZM4.224,8.059v.005c.838,0,1.679.041,2.514-.011a1.44,1.44,0,0,0,1.3-1.786,1.466,1.466,0,0,0-1.529-1.14c-1.529-.018-3.058-.009-4.588,0A1.88,1.88,0,0,0,1.3,5.24,1.458,1.458,0,0,0,.367,6.763,1.424,1.424,0,0,0,1.661,8.047C2.513,8.095,3.369,8.059,4.224,8.059Z",
    fill: "#00bcc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2971",
    "data-name": "Trac\\xE9 2971",
    d: "M-6,244.226a23.246,23.246,0,0,1,.8-3.141,11.313,11.313,0,0,1,9.721-7.461c.049-.006.1-.011.146-.02.008,0,.013-.019.048-.076a7.272,7.272,0,0,1-5.631-3.944,6.988,6.988,0,0,1-.612-4.943,7.279,7.279,0,0,1,14.313.732A7.337,7.337,0,0,1,6.6,233.524a24.046,24.046,0,0,1,3.144.85,11.267,11.267,0,0,1,7.2,8.9c.091.5.1,1.014.163,1.521a2.214,2.214,0,0,1-1.355,2.6H-4.615A2.451,2.451,0,0,1-6,246.006Z",
    transform: "translate(0 -202.757)",
    fill: "#00bcc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2972",
    "data-name": "Trac\\xE9 2972",
    d: "M302.108,38.416c4.884.8,7.722,3.542,8.669,8.318H292.026a9.288,9.288,0,0,1,2.8-5.628,9.66,9.66,0,0,1,5.7-2.664,6.239,6.239,0,0,1-5.294-6.715,6.169,6.169,0,0,1,12.3.086A6.248,6.248,0,0,1,302.108,38.416Z",
    transform: "translate(-268.553 -28.923)",
    fill: "#00bcc9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn2Process);
export default __webpack_public_path__ + "static/media/icn2-process.2a020fdeb6d7656ff29b319bf997bf54.svg";
export { ForwardRef as ReactComponent };